import React from 'react';

import { clearError, clearAllErrors } from '../../actions/errorActions';

import { DEFAULT_ERROR_MESSAGE } from '../../constants/errorMessage';
import { DisclaimerHtml } from './miscComponents';
import { Alert } from 'reactstrap';
import { Link } from 'react-router-dom';
import { RootState, useAppDispatch, useAppSelector } from '../../store';

const ActiveErrors: React.FC = () => {
    const dispatch = useAppDispatch();

    const {
        activeErrors,
        bookingErrorCorrelationKey,
        errorMessageOverride,
        errorLink,
        errorLinkText,
        detailedErrors
    } = useAppSelector((state: RootState) => ({
        activeErrors: state.apiErrors.activeErrors,
        bookingErrorCorrelationKey: state.apiErrors.bookingErrorCorrelationKey,
        errorMessageOverride: state.config.instance.errorMessageOverride,
        errorLink: state.config.instance.errorLink,
        errorLinkText: state.config.instance.errorLinkText,
        detailedErrors: state.apiErrors.detailedErrors
    }));

    const dismiss = (e:any, actionId: string) => {
            e.preventDefault();
            dispatch(clearError(actionId));
    };

    const dismissAll = () => {
        dispatch(clearAllErrors());
    };

    let className = errorMessageOverride ? 'page-error' : 'page-error default';

    let effectiveErrorMessage = errorMessageOverride || DEFAULT_ERROR_MESSAGE;
    if (bookingErrorCorrelationKey)
        effectiveErrorMessage += ` [ERROR REF: ${bookingErrorCorrelationKey}]`;

    if (detailedErrors)
        return (
            activeErrors && activeErrors.length > 0 ? (
                activeErrors.map((currentError: any, i: number) =>
                    <Alert key={i} color="danger" isOpen={true} toggle={(event) => dismiss(event, currentError.actionId)}>
                        {currentError.error.detail}
                    </Alert>
                )
            ) : null);
    else
        return (
            activeErrors && activeErrors.length > 0 ? (
                <>
                    <DisclaimerHtml
                        className={className}
                        text={effectiveErrorMessage}
                        isVisible={true}
                    />
                    {errorLink &&
                        <div className={className}>
                            <Link to={errorLink}>{errorLinkText}</Link>
                        </div>
                    }
                </>
            ) : null
        );
}
export default ActiveErrors;